"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.boxDpdToCode = exports.boxToCode = exports.boxFromCode = exports.boxAI = void 0;
const errors_1 = require("@wolf/errors");
const models_1 = require("./models");
const types_1 = require("./types");
const utils_1 = require("./utils");
exports.boxAI = {
    '90': 'type',
    '20': 'sourceId',
    '251': 'workspaceId',
    '91': 'deliveryGroupId',
    '92': 'boxId',
};
const boxFromCode = (code) => {
    try {
        const codes = (0, utils_1.stringToCodes)(code);
        if ('productId' in codes) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Incorrect format');
        }
        const box = codes.reduce((previousCodes, code) => {
            return {
                ...previousCodes,
                [exports.boxAI[code.code]]: Number(code.value),
            };
        }, {});
        const boxParse = models_1.BoxFromBarcode.safeParse(box);
        if (!boxParse.success || boxParse.data.type !== Number(types_1.type.box)) {
            throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, 'Invalid identifier');
        }
        return boxParse.data;
    }
    catch (error) {
        throw new errors_1.ApplicationError(`Unknown error ${error}`);
    }
};
exports.boxFromCode = boxFromCode;
const boxToCode = (box) => {
    const swappedBoxAI = Object.entries(exports.boxAI).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
    const code = Object.keys(box).reduce((previousCode, key) => {
        return (previousCode +
            '(' +
            swappedBoxAI[key] +
            ')' +
            (0, utils_1.formatToCode)(box[key]));
    }, '');
    return types_1.typeIA + types_1.type.box + code;
};
exports.boxToCode = boxToCode;
const boxDpdToCode = (box) => {
    const swappedBoxAI = Object.entries(exports.boxAI).reduce((acc, [key, value]) => ({ ...acc, [value]: key }), {});
    const code = Object.keys(box).reduce((previousCode, key) => {
        // To reduce length we do not include the deliveryGroupId in the barcodes of dpd. We include it in another field.
        if (key === 'deliveryGroupId')
            return previousCode;
        return (previousCode +
            '(' +
            swappedBoxAI[key] +
            ')' +
            (0, utils_1.formatToCode)(box[key]));
    }, '');
    return types_1.typeIA + types_1.type.box + code + '#';
};
exports.boxDpdToCode = boxDpdToCode;
//# sourceMappingURL=box.js.map